// src/i18n/broadcast.ts —— 06 agent-portal A-11「推广推送」（Bot 广告推送，2026-10-21 拍板）[新增 key]；中英文为本功能定稿
export const I18N_BROADCAST = {
  zh: {
    broadcast: '推广推送', // 导航 / 页名（page 键）
    hBroadcast: '通过你名下的 Bot，向私聊过它的用户推送推广消息',
    // 整页状态
    bcOffTitle: '推广推送暂未开放',
    bcOffText: '平台尚未为代理开放推广推送，如需使用请联系平台。',
    bcLoading: '加载中…',
    bcRetry: '重试',
    // 配额与说明
    bcQuotaTitle: '今日配额',
    bcQuotaBot: '@{bot}：今日已用 {used} / {max} 次',
    bcQuotaNoBot: '你名下暂无可用的 Bot',
    bcQuotaTargets: '单次最多发送 {n} 人',
    bcQuotaPeriodic: '进行中的周期活动 {used} / {max} 个',
    bcNoteReview: '需平台审核：提交后状态为「待审核」，平台审核通过后按计划发送。',
    bcNoteNoReview: '无需平台审核：提交后按计划发送。',
    bcNoteAudience: '只会发给私聊过你的 Bot 的用户（已退订、已拉黑 Bot 的用户自动排除）；功能上线初期可送达人数可能偏少。',
    bcNoteFooter: '每条消息末尾会自动附加退订提示「回复 /stop_ads 退订推广消息」。',
    // 列表
    bcNew: '新建推送',
    bcColTitle: '名称',
    bcColBots: 'Bot',
    bcColSchedule: '时间规则',
    bcColStatus: '状态',
    bcColNext: '下次执行',
    bcColLast: '最近一次（已发 / 目标）',
    bcEmpty: '还没有推送活动',
    bcPrev: '上一页',
    bcNext: '下一页',
    bcTotal: '共 {n} 条',
    bcStDraft: '草稿',
    bcStPendingReview: '待审核',
    bcStRejected: '已驳回',
    bcStScheduled: '已排期',
    bcStPaused: '已暂停',
    bcStDone: '已完成',
    bcStCancelled: '已取消',
    // 调度文本
    bcSchNow: '立即发送',
    bcSchOnce: '定时一次',
    bcSchDaily: '每天',
    bcSchWeekly: '每周',
    bcSchTextOnce: '定时 {at}',
    bcSchTextDaily: '每天 {time}',
    bcSchTextWeekly: '每周{days} {time}',
    bcSchTextEnd: '，至 {date}',
    bcWdSep: '、',
    bcWd1: '一',
    bcWd2: '二',
    bcWd3: '三',
    bcWd4: '四',
    bcWd5: '五',
    bcWd6: '六',
    bcWd7: '日',
    bcTz: '时区：{tz}',
    // 编辑器
    bcEditNew: '新建推送',
    bcEditTitle: '编辑推送',
    bcBack: '返回列表',
    bcFTitle: '活动名称（仅自己可见，不会发送）',
    bcFTitlePh: '如：十一月开卡优惠',
    bcFBots: '发送 Bot',
    bcFBotsHint: '只能选择你名下的 Bot',
    bcFCard: '持卡筛选',
    bcCardAny: '不限',
    bcCardHas: '已开卡用户',
    bcCardNone: '未开卡用户',
    bcFLang: '语言筛选',
    bcLangAny: '不限',
    bcLangZh: '中文用户',
    bcLangEn: '英文用户',
    bcFTextZh: '中文文案',
    bcFTextEn: '英文文案（留空则英文用户收到中文文案）',
    bcTagHint: '支持标签：<b>粗体</b> <i>斜体</i> <u>下划线</u> <s>删除线</s> <code>代码</code> <a href="https://…">链接</a>；其他标签会按原文显示。',
    bcCount: '{n} / {max}（含退订尾注）',
    bcFImage: '图片（可选，jpg / png / webp，不超过 5MB；带图时文案上限 1024 字，无图 4096 字）',
    bcImgPick: '选择图片',
    bcImgRemove: '移除图片',
    bcImgUploading: '上传中…',
    bcFButtons: '按钮（最多 3 个）',
    bcBtnAdd: '添加按钮',
    bcBtnRemove: '删除',
    bcBtnKindUrl: '打开链接',
    bcBtnKindWebapp: '打开 Mini App',
    bcBtnLabelZh: '中文按钮文字',
    bcBtnLabelEn: '英文按钮文字（可选）',
    bcBtnUrl: 'https:// 链接',
    bcFSchedule: '发送时间',
    bcFRunAt: '发送时间',
    bcFTime: '发送时刻（HH:MM）',
    bcFWeekdays: '每周发送日',
    bcFEndDate: '结束日期（可选，含当天）',
    bcEstimate: '预估人数',
    bcEstTotal: '预计送达 {n} 人',
    bcEstBot: '@{bot}：{n} 人',
    bcEstCapped: '超过单次上限，只会发送前 {max} 人',
    bcPreviewTitle: '消息预览',
    bcPreviewZh: '中文',
    bcPreviewEn: 'English',
    bcPreviewEmpty: '（文案为空）',
    bcSaveDraft: '保存草稿',
    bcSendPreview: '发给我预览',
    bcSubmit: '提交',
    bcSubmitReview: '提交审核',
    // 详情
    bcDBots: '发送 Bot',
    bcDFilter: '受众筛选',
    bcDSchedule: '时间规则',
    bcDNext: '下次执行',
    bcDUpdated: '更新时间',
    bcDReject: '平台驳回原因',
    bcDRejectHint: '可修改文案后重新提交。',
    bcDEditHint: '已排期的活动修改后会变为草稿，需要重新提交。',
    bcRuns: '执行记录',
    bcRunsEmpty: '暂无执行记录',
    bcRColPlanned: '计划时间',
    bcRColStatus: '状态',
    bcRColProgress: '已发 / 目标',
    bcRColFailed: '失败',
    bcRColSkipped: '跳过',
    bcRColFinished: '完成时间',
    bcTruncated: '已截断',
    bcAEdit: '编辑',
    bcAEditResubmit: '修改后重新提交',
    bcAPause: '暂停',
    bcAResume: '继续',
    bcACancel: '取消活动',
    // run 详情
    bcRunTitle: '执行 #{id}',
    bcBackDetail: '返回活动',
    bcRunProgress: '进度 {done} / {total}',
    bcRunSent: '已发送',
    bcRunBlocked: '已拉黑',
    bcRunNotFound: '未找到',
    bcRunOther: '其他失败',
    bcRunSkipped: '已跳过',
    bcRunTruncatedNote: '目标人数超过单次上限，已截断。',
    bcRunPolling: '进行中，每 5 秒自动刷新',
    bcRsQueued: '排队中',
    bcRsSnapshotting: '生成名单中',
    bcRsSending: '发送中',
    bcRsPaused: '已暂停',
    bcRsDone: '已完成',
    bcRsCancelled: '已取消',
    bcRsFailed: '失败',
    bcDlFailed: '全部失败',
    bcDlBlocked: '拉黑',
    bcDlNotFound: '未找到',
    bcDlSkipped: '已跳过',
    bcDlUser: '用户',
    bcDlBot: 'Bot',
    bcDlStatus: '状态',
    bcDlReason: '原因',
    bcDlTime: '时间',
    bcDlEmpty: '暂无记录',
    bcDsPending: '待发送',
    bcDsSending: '发送中',
    bcDsSent: '已发送',
    bcDsFailed: '失败',
    bcDsSkipped: '已跳过',
    bcFkBlocked: '用户已拉黑 Bot 或已停用',
    bcFkNotFound: '会话不存在',
    bcFkRejected: '被 Telegram 拒绝',
    bcFkBotInactive: 'Bot 已停用',
    bcFkTransient: '临时错误或状态未知',
    bcFkPartial: '部分发送',
    // 确认框
    bcCfCancelTitle: '取消这个推送活动？',
    bcCfCancelText: '取消后尚未发送的消息不会再发送，操作不可恢复。',
    bcCfCancelOk: '确认取消',
    bcCfSubmitTitle: '提交前请确认',
    bcCfSubmitOk: '仍然提交',
    bcCfBack: '返回',
    bcWarnDaily: '以下 Bot 今日推送次数已用完：{bots}，提交后可能被拒绝。',
    bcWarnPeriodic: '进行中的周期活动已达上限（{max} 个），提交后可能被拒绝。',
    bcWarnTargets: '预计人数 {n} 超过单次上限 {max}，超出部分不会发送。',
    // 反馈
    bcToastSaved: '已保存',
    bcToastPreview: '预览已发送到你的 Telegram',
    bcToastSubmittedReview: '已提交，等待平台审核',
    bcToastSubmitted: '已提交，将按计划发送',
    bcToastPaused: '已暂停',
    bcToastResumed: '已继续',
    bcToastCancelled: '活动已取消',
    bcErrTitle: '请填写活动名称（不超过 64 字）',
    bcErrBots: '请选择 1～10 个 Bot',
    bcErrTextZh: '请填写中文文案',
    bcErrTooLong: '{lang}文案超出长度上限（{n} / {max}）',
    bcErrBtnLabel: '请填写第 {i} 个按钮的中文文字',
    bcErrBtnUrl: '第 {i} 个按钮的链接不可用：{why}',
    bcUrlFormat: '链接格式不正确',
    bcUrlScheme: '只支持 https 链接',
    bcUrlUserinfo: '链接不能包含账号信息',
    bcUrlTme: 'Telegram 链接只允许公开用户名（可带 ?start=），不支持邀请链接',
    bcErrRunAt: '请选择晚于当前时间的发送时间',
    bcErrTime: '请填写正确的发送时刻（HH:MM）',
    bcErrWeekdays: '请至少选择一个发送日',
    bcErrEndDate: '结束日期格式不正确或早于今天',
    bcErrImgType: '只支持 jpg / png / webp 图片',
    bcErrImgSize: '图片不能超过 5MB',
    bcErrFeatureOff: '平台已关闭推广推送',
    bcErrQuota: '已达推送配额或操作过于频繁，请稍后再试',
    bcErrStatus: '活动状态已变化，已刷新',
    bcErrStale: '活动已在别处更新，已刷新为最新内容',
    bcErrNoTg: '你的账号未登记 Telegram 数字 ID，暂不能预览，请联系平台',
    bcErrPreviewBlocked: '预览发送失败：请先在所选 Bot 中发送 /start 后重试',
    bcErrNotFound: '活动不存在',
    bcErrField: '「{field}」填写不正确',
    bcErrTooLongSrv: '文案超出长度上限（含退订尾注）',
    bcLangNameZh: '中文',
    bcLangNameEn: '英文',
  },
  en: {
    broadcast: 'Promotions',
    hBroadcast: 'Send promotional messages through your bots to users who have chatted with them',
    bcOffTitle: 'Promotions are not available',
    bcOffText: 'The platform has not enabled promotions for agents. Please contact the platform.',
    bcLoading: 'Loading…',
    bcRetry: 'Retry',
    bcQuotaTitle: "Today's quota",
    bcQuotaBot: '@{bot}: {used} / {max} used today',
    bcQuotaNoBot: 'You have no active bots',
    bcQuotaTargets: 'Up to {n} recipients per send',
    bcQuotaPeriodic: 'Active recurring campaigns: {used} / {max}',
    bcNoteReview: 'Platform review required: submitted campaigns stay "Pending review" until the platform approves them.',
    bcNoteNoReview: 'No review required: submitted campaigns are sent as scheduled.',
    bcNoteAudience: 'Only users who have privately chatted with your bot receive it (opted-out users and users who blocked the bot are excluded). Reach may be low at first.',
    bcNoteFooter: 'Every message automatically ends with the opt-out line "Reply /stop_ads to unsubscribe".',
    bcNew: 'New campaign',
    bcColTitle: 'Name',
    bcColBots: 'Bots',
    bcColSchedule: 'Schedule',
    bcColStatus: 'Status',
    bcColNext: 'Next run',
    bcColLast: 'Last run (sent / target)',
    bcEmpty: 'No campaigns yet',
    bcPrev: 'Previous',
    bcNext: 'Next',
    bcTotal: '{n} total',
    bcStDraft: 'Draft',
    bcStPendingReview: 'Pending review',
    bcStRejected: 'Rejected',
    bcStScheduled: 'Scheduled',
    bcStPaused: 'Paused',
    bcStDone: 'Done',
    bcStCancelled: 'Cancelled',
    bcSchNow: 'Send now',
    bcSchOnce: 'Once',
    bcSchDaily: 'Daily',
    bcSchWeekly: 'Weekly',
    bcSchTextOnce: 'At {at}',
    bcSchTextDaily: 'Daily at {time}',
    bcSchTextWeekly: 'Every {days} at {time}',
    bcSchTextEnd: ', until {date}',
    bcWdSep: ', ',
    bcWd1: 'Mon',
    bcWd2: 'Tue',
    bcWd3: 'Wed',
    bcWd4: 'Thu',
    bcWd5: 'Fri',
    bcWd6: 'Sat',
    bcWd7: 'Sun',
    bcTz: 'Time zone: {tz}',
    bcEditNew: 'New campaign',
    bcEditTitle: 'Edit campaign',
    bcBack: 'Back to list',
    bcFTitle: 'Campaign name (internal, never sent)',
    bcFTitlePh: 'e.g. November card promo',
    bcFBots: 'Send from bots',
    bcFBotsHint: 'Only your own bots can be selected',
    bcFCard: 'Card filter',
    bcCardAny: 'Anyone',
    bcCardHas: 'Users with cards',
    bcCardNone: 'Users without cards',
    bcFLang: 'Language filter',
    bcLangAny: 'Any',
    bcLangZh: 'Chinese users',
    bcLangEn: 'English users',
    bcFTextZh: 'Chinese text',
    bcFTextEn: 'English text (leave blank to send the Chinese text to English users)',
    bcTagHint: 'Supported tags: <b>bold</b> <i>italic</i> <u>underline</u> <s>strike</s> <code>code</code> <a href="https://…">link</a>. Other tags are shown as typed.',
    bcCount: '{n} / {max} (incl. opt-out line)',
    bcFImage: 'Image (optional, jpg / png / webp, up to 5MB; text limit 1024 with an image, 4096 without)',
    bcImgPick: 'Choose image',
    bcImgRemove: 'Remove image',
    bcImgUploading: 'Uploading…',
    bcFButtons: 'Buttons (up to 3)',
    bcBtnAdd: 'Add button',
    bcBtnRemove: 'Remove',
    bcBtnKindUrl: 'Open link',
    bcBtnKindWebapp: 'Open Mini App',
    bcBtnLabelZh: 'Chinese label',
    bcBtnLabelEn: 'English label (optional)',
    bcBtnUrl: 'https:// link',
    bcFSchedule: 'When to send',
    bcFRunAt: 'Send at',
    bcFTime: 'Time of day (HH:MM)',
    bcFWeekdays: 'Days of week',
    bcFEndDate: 'End date (optional, inclusive)',
    bcEstimate: 'Estimate reach',
    bcEstTotal: 'About {n} recipients',
    bcEstBot: '@{bot}: {n}',
    bcEstCapped: 'Over the per-send limit; only the first {max} will be sent',
    bcPreviewTitle: 'Preview',
    bcPreviewZh: '中文',
    bcPreviewEn: 'English',
    bcPreviewEmpty: '(empty)',
    bcSaveDraft: 'Save draft',
    bcSendPreview: 'Send me a preview',
    bcSubmit: 'Submit',
    bcSubmitReview: 'Submit for review',
    bcDBots: 'Bots',
    bcDFilter: 'Audience',
    bcDSchedule: 'Schedule',
    bcDNext: 'Next run',
    bcDUpdated: 'Updated',
    bcDReject: 'Rejection reason',
    bcDRejectHint: 'Edit the content and submit again.',
    bcDEditHint: 'Editing a scheduled campaign turns it back into a draft; submit it again afterwards.',
    bcRuns: 'Runs',
    bcRunsEmpty: 'No runs yet',
    bcRColPlanned: 'Planned',
    bcRColStatus: 'Status',
    bcRColProgress: 'Sent / target',
    bcRColFailed: 'Failed',
    bcRColSkipped: 'Skipped',
    bcRColFinished: 'Finished',
    bcTruncated: 'Truncated',
    bcAEdit: 'Edit',
    bcAEditResubmit: 'Edit and resubmit',
    bcAPause: 'Pause',
    bcAResume: 'Resume',
    bcACancel: 'Cancel campaign',
    bcRunTitle: 'Run #{id}',
    bcBackDetail: 'Back to campaign',
    bcRunProgress: 'Progress {done} / {total}',
    bcRunSent: 'Sent',
    bcRunBlocked: 'Blocked',
    bcRunNotFound: 'Not found',
    bcRunOther: 'Other failures',
    bcRunSkipped: 'Skipped',
    bcRunTruncatedNote: 'The audience exceeded the per-send limit and was truncated.',
    bcRunPolling: 'In progress, refreshing every 5 seconds',
    bcRsQueued: 'Queued',
    bcRsSnapshotting: 'Building list',
    bcRsSending: 'Sending',
    bcRsPaused: 'Paused',
    bcRsDone: 'Done',
    bcRsCancelled: 'Cancelled',
    bcRsFailed: 'Failed',
    bcDlFailed: 'All failed',
    bcDlBlocked: 'Blocked',
    bcDlNotFound: 'Not found',
    bcDlSkipped: 'Skipped',
    bcDlUser: 'User',
    bcDlBot: 'Bot',
    bcDlStatus: 'Status',
    bcDlReason: 'Reason',
    bcDlTime: 'Time',
    bcDlEmpty: 'No records',
    bcDsPending: 'Pending',
    bcDsSending: 'Sending',
    bcDsSent: 'Sent',
    bcDsFailed: 'Failed',
    bcDsSkipped: 'Skipped',
    bcFkBlocked: 'User blocked the bot or is deactivated',
    bcFkNotFound: 'Chat not found',
    bcFkRejected: 'Rejected by Telegram',
    bcFkBotInactive: 'Bot inactive',
    bcFkTransient: 'Temporary error or unknown state',
    bcFkPartial: 'Partially sent',
    bcCfCancelTitle: 'Cancel this campaign?',
    bcCfCancelText: 'Messages not yet sent will not be sent. This cannot be undone.',
    bcCfCancelOk: 'Cancel campaign',
    bcCfSubmitTitle: 'Please confirm',
    bcCfSubmitOk: 'Submit anyway',
    bcCfBack: 'Back',
    bcWarnDaily: "Today's sends are used up for: {bots}. Submitting may be rejected.",
    bcWarnPeriodic: 'Active recurring campaigns are at the limit ({max}). Submitting may be rejected.',
    bcWarnTargets: 'Estimated {n} recipients exceeds the per-send limit of {max}; the rest will not be sent.',
    bcToastSaved: 'Saved',
    bcToastPreview: 'Preview sent to your Telegram',
    bcToastSubmittedReview: 'Submitted for platform review',
    bcToastSubmitted: 'Submitted; it will be sent as scheduled',
    bcToastPaused: 'Paused',
    bcToastResumed: 'Resumed',
    bcToastCancelled: 'Campaign cancelled',
    bcErrTitle: 'Enter a campaign name (up to 64 characters)',
    bcErrBots: 'Select 1 to 10 bots',
    bcErrTextZh: 'Enter the Chinese text',
    bcErrTooLong: '{lang} text is too long ({n} / {max})',
    bcErrBtnLabel: 'Enter the Chinese label for button {i}',
    bcErrBtnUrl: 'Button {i} link is not allowed: {why}',
    bcUrlFormat: 'invalid link',
    bcUrlScheme: 'only https links are allowed',
    bcUrlUserinfo: 'links must not contain credentials',
    bcUrlTme: 'Telegram links must be a public username (optionally with ?start=); invite links are not allowed',
    bcErrRunAt: 'Choose a send time in the future',
    bcErrTime: 'Enter a valid time of day (HH:MM)',
    bcErrWeekdays: 'Select at least one day',
    bcErrEndDate: 'End date is invalid or before today',
    bcErrImgType: 'Only jpg / png / webp images are supported',
    bcErrImgSize: 'Image must be 5MB or smaller',
    bcErrFeatureOff: 'The platform has turned off promotions',
    bcErrQuota: 'Send quota reached or too many requests. Please try again later.',
    bcErrStatus: 'The campaign status changed; refreshed',
    bcErrStale: 'The campaign was updated elsewhere; refreshed to the latest version',
    bcErrNoTg: 'Your account has no Telegram numeric ID on file. Contact the platform to enable previews.',
    bcErrPreviewBlocked: 'Preview failed: send /start to the selected bot first, then retry',
    bcErrNotFound: 'Campaign not found',
    bcErrField: '"{field}" is invalid',
    bcErrTooLongSrv: 'Text is too long (including the opt-out line)',
    bcLangNameZh: 'Chinese',
    bcLangNameEn: 'English',
  },
} as const;
